import React, {useEffect, useState} from "react"
import {KTIcon} from "../../../../../_websoft/helpers"
import DopLanguageButtons from "./DopLanguageButtons"

import {
    getDopSifre
} from "../../../../api/paneliDop"

import {
    getSifraDetails
} from "../../../../api/paneliSifre"

type Props = {
    isOpen: boolean
    onClose: () => void
    dopId: number | null
}

type SifraItem = {
    Id: number
    sifra: string
}

const DopPdfModal = ({
                         isOpen,
                         onClose,
                         dopId
                     }: Props) => {

    const [dbSifre, setDbSifre] = useState<SifraItem[]>([])
    const [loading, setLoading] = useState(false)

    const [selectedSifra, setSelectedSifra] =
        useState<SifraItem | null>(null)

    const [sifraDetails, setSifraDetails] =
        useState<any>(null)

    useEffect(() => {

        if (!dopId || !isOpen) return

        loadSifre()

    }, [dopId, isOpen])

    const loadSifre = async () => {

        try {

            if (!dopId) return

            setLoading(true)

            const data = await getDopSifre(dopId)

            const sifre = data.map((item: any) => ({
                Id: item.Id,
                sifra: item.sifre_panela?.sifra
            }))

            setDbSifre(sifre)

        } catch (e) {

            console.error(e)

        } finally {

            setLoading(false)

        }
    }

    const handleSelectSifra = async (item: SifraItem) => {

        try {

            setSelectedSifra(item)

            const details = await getSifraDetails(item.sifra)

            console.log('SIFRA DETAILS:', details)

            setSifraDetails(details)

        } catch (e) {

            console.error(e)

        }
    }

    if (!isOpen) return null

    return (
        <div
            className="modal fade show d-block"
            style={{background: 'rgba(0,0,0,0.7)'}}
        >
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content shadow-lg rounded-4">

                    {/* HEADER */}
                    <div className="modal-header border-0 pb-2">

                        <div>
                            <h3 className="fw-bold mb-1 d-flex align-items-center gap-2">
                                <KTIcon
                                    iconName="file-down"
                                    className="fs-2 text-primary"
                                />

                                Generisanje PDF-a
                            </h3>

                            <div className="text-muted fs-7">
                                Odaberite šifru i jezik za generisanje dokumenta
                            </div>
                        </div>

                        <button
                            className="btn btn-sm btn-light"
                            onClick={onClose}
                        >
                            <KTIcon iconName="cross"/>
                        </button>

                    </div>

                    {/* BODY */}
                    <div className="modal-body pt-4">

                        {/* STEP INDICATOR */}
                        <div className="d-flex justify-content-between mb-6">

                            <div className={`fw-bold ${
                                !selectedSifra
                                    ? 'text-primary'
                                    : 'text-muted'
                            }`}>
                                1. Šifra
                            </div>

                            <div className={`fw-bold ${
                                selectedSifra
                                    ? 'text-primary'
                                    : 'text-muted'
                            }`}>
                                2. Jezik
                            </div>

                        </div>

                        {/* STEP 1 */}
                        <div className="mb-7">

                            <h5 className="fw-bold mb-4">
                                Odaberi šifru
                            </h5>

                            {loading ? (

                                <div className="text-center py-10">
                                    <div className="spinner-border text-primary"/>
                                </div>

                            ) : dbSifre.length === 0 ? (

                                <div className="alert alert-light-danger">
                                    Nema dostupnih šifri
                                </div>

                            ) : (

                                <div className="row g-3">

                                    {dbSifre.map((item) => {

                                        const isActive =
                                            selectedSifra?.sifra === item.sifra

                                        return (

                                            <div
                                                key={item.Id}
                                                className="col-4"
                                            >

                                                <div
                                                    className={`card cursor-pointer border ${
                                                        isActive
                                                            ? 'border-primary shadow-sm'
                                                            : 'border-gray-300'
                                                    }`}
                                                    onClick={() => handleSelectSifra(item)}
                                                    style={{
                                                        transition: 'all 0.2s'
                                                    }}
                                                >

                                                    <div className="card-body text-center py-4">

                                                        <div
                                                            className={`fw-bold fs-4 ${
                                                                isActive
                                                                    ? 'text-primary'
                                                                    : ''
                                                            }`}
                                                        >
                                                            {item.sifra}
                                                        </div>

                                                        {sifraDetails && isActive && (
                                                            <div className="mt-3">

                                                                <div className="text-muted fs-7">
                                                                    Debljina:
                                                                    {' '}
                                                                    {sifraDetails?.debljina} mm
                                                                </div>

                                                                <div className="text-muted fs-7">
                                                                    Lim:
                                                                    {' '}
                                                                    {sifraDetails?.debljinaLimaGore}
                                                                    {' / '}
                                                                    {sifraDetails?.debljinaLimaDole}
                                                                </div>

                                                            </div>
                                                        )}

                                                        {isActive && (
                                                            <div className="mt-3 text-primary">
                                                                <KTIcon
                                                                    iconName="check-circle"
                                                                    className="fs-2"
                                                                />
                                                            </div>
                                                        )}

                                                    </div>

                                                </div>

                                            </div>

                                        )
                                    })}

                                </div>

                            )}

                        </div>

                        {/* STEP 2 */}
                        {selectedSifra && sifraDetails && (

                            <div className="mt-8">

                                <h5 className="fw-bold mb-4">
                                    Odaberi jezik

                                    <span className="text-muted fs-7 ms-2">
                                        ({selectedSifra.sifra})
                                    </span>
                                </h5>

                                <DopLanguageButtons
                                    buttonClassName="btn btn-light-primary py-4 px-5"
                                    onSelect={(langKey) => {

                                        if (!dopId) return

                                        const url =
                                            `../digitalni-dop-wizzard-pdf/${dopId}` +
                                            `?lang=${langKey}` +
                                            `&sifraArtikla=${selectedSifra.sifra}` +
                                            `&debljina=${sifraDetails?.debljina}` +
                                            `&debljinaLimaGore=${sifraDetails?.debljinaLimaGore}` +
                                            `&debljinaLimaDole=${sifraDetails?.debljinaLimaDole}`

                                        window.open(url, '_blank')
                                    }}
                                />

                            </div>

                        )}

                    </div>

                </div>
            </div>
        </div>
    )
}

export default DopPdfModal